const documentationTabDetails = [
  {
    name: 'Concepts',
    logo: 'onboarding/concepts',
    link: 'https://www.lambdatest.com/support/docs/he-concepts/',
    eventName: 'concepts',
    description:
      'Everything you need to know about Hyperexecute and it’s components.',
  },
  {
    name: 'Features',
    logo: 'onboarding/feature',
    link: 'https://www.lambdatest.com/support/docs/key-features-of-hyperexecute/',
    eventName: 'features',
    description:
      'Curious? Learn more about Hyperexecute Features and how it can help you in your testing journey',
  },
  {
    name: 'Guided Walkthrough',
    logo: 'onboarding/guided-tour',
    link: 'https://www.lambdatest.com/support/docs/he-guided-walkthrough/',
    eventName: 'guided walkthrough',
    description:
      'Want to take the tour once again? This time at your own pace in the form of documentation.',
  },
  {
    name: 'Hyperexecute CLI',
    logo: 'onboarding/cli',
    link: 'https://www.lambdatest.com/support/docs/hyperexecute-cli-run-tests-on-hyperexecute-grid/',
    eventName: 'hypex cli',
    description:
      'Hyperexecute can be driven through a CLI binary which provides you complete ease of access.',
  },
  {
    name: 'HyperExecute YAML',
    logo: 'onboarding/yaml',
    link: 'https://www.lambdatest.com/support/docs/deep-dive-into-hyperexecute-yaml/',
    eventName: 'hypex yaml',
    description:
      'Ready to jump on the driver’s seat. Hyperexecute is configurable through a simple YAML file.',
  },
  {
    name: 'Integrations',
    logo: 'onboarding/integration',
    link: 'https://www.lambdatest.com/support/docs/integration-with-hyperexecute/',
    eventName: 'integrations',
    description:
      'Hyperexecute is language and framework agnostic. If you can run it your local, it’s fair to say that you can run it here too.',
  },
];

export default documentationTabDetails;
